import moment from "moment";
/* eslint-disable import/prefer-default-export */
/**
 * @param {String} utcTime date in utc time zone
 * @return {String} date in local time zone
 */
export const convertUtcToLocal = (utcTime) => moment.utc(utcTime).local().format();
